<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <div class="d-flex flex-row flex-wrap align-items-center justify-content-between mb-3" style="padding: 20px">
            <h3 class="h5 font-weight-semibold mb-0" style="color: #2F2F2F;">Detail Mapping QR Code</h3>
            <div class="d-flex flex-row align-items-center">
                <div class="d-flex flex-row align-items-center flex-wrap">
                    <div style="width: 170px; margin: 5px 8px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="options.year"
                            :allow-empty="false"
                            class="qtrust-select"
                            placeholder="Semua Tahun"
                        ></MultiSelect>
                    </div>
                    <div style="width: 170px; margin: 5px 8px;">
                        <MultiSelect
                            v-model="filter.month"
                            :options="options.month.map(type => type.value)"
                            :custom-label="opt => options.month.find(x => x.value == opt).title"
                            class="qtrust-select"
                            placeholder="Semua Bulan"
                        ></MultiSelect>
                    </div>
                    <button
                        type="button"
                        class="btn btn-download-csv"
                        @click="exportToCSV"
                    >
                        Download CSV <i class="fas fa-file-download ml-2"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="w-100 overflow-auto">
            <table class="table w-100 qtrust-table">
                <thead>
                    <tr>
                        <th>QR Code</th>
                        <th>Serial Number</th>
                        <th>Tanggal Mapping</th>
                        <th>Nomor Mesin</th>
                        <th>Mapping History</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(dat, idx) in displayData" :key="idx">
                        <td>{{ dat.qrcode ? dat.qrcode : '-' }}</td>
                        <td>{{ dat.serial_number ? dat.serial_number : '-' }}</td>
                        <td>{{ dat.active_date ? (moment(dat.active_date).isValid() ? moment(dat.active_date).format('DD MMM YYYY | HH:mm') : dat.active_date) : '-' }}</td>
                        <td>{{ dat.engine_no ? dat.engine_no : '-' }}</td>
                        <td>
                            <button 
                                @click="showHistory(dat)"
                                type="button" 
                                style="padding: 0; margin: 0; background: transparent; border: none; box-shadow: none; color: #F36F21; font-weight: 500; cursor: pointer; font-size: 13px;"
                            >
                                See History
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="d-flex justify-content-end align-items-center py-2 px-3">
            <p class="text-muted mb-0" style="font-size: 13px;">
                Showing {{ totalCount ? (config.page-1)*config.limit+1 : 0 }}-{{ Math.min(config.page*config.limit, totalCount) }} of {{ totalCount }} Items
            </p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0" style="font-size: 13px;">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= lastPageCount" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= lastPageCount" @click="goToPage(lastPageCount)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>

        <!-- History Modal -->
        <modal
            v-if="modal.modalHistory"
            box-class="col-11 col-md-8 col-lg-6"
            :box-style="{
                'background': 'white',
                'margin': '0 auto',
                'border-radius': '8px',
                'overflow': 'hidden',
                'box-shadow': '0 0 10px 0 rgba(0, 0, 0, 0.1)',
                'padding': '0'
            }"
            @closeModal="modal.modalHistory = false"
        >
            <modal-history
                :data="modal.dataHistory"
                @closeModal="modal.modalHistory = false"
            ></modal-history>
        </modal>
    </div>
</template>

<script>
import moment from 'moment';
import * as XLSX from 'xlsx';
import modal from '@/components/modal.vue';
import modalHistory from '@/views/DealerDashboard/QRCode/RepeatedMapping/children/modalHistory.vue';

export default {
    data() {
        return {
            moment: moment,
            modal: {
                dataHistory: null,
                modalHistory: false
            },
            options: {
                year: [...new Set(Array.from({length: 5}, (_, i) => Math.max(parseInt(moment().format('YYYY')) - i, 2024)))],
                month: Array.from({length: 12}, (_, i) => ({title: moment().month(i).format('MMMM'), value: i + 1})),
            },
            filter: {
                year: 2024,
                month: null,
            },
            config: {
                lastPage: 1,
                total: 5,
                page: 1,
                limit: 5,
            },
            data: null,
            dummyData: [
                { qrcode: 'qs23357mpm679356', serial_number: '100020501', active_date: '2024-01-02 13:39:00', engine_no: 'JHBA12345JM' },
                { qrcode: 'qs23357mpm679357', serial_number: '100020502', active_date: '2024-01-13 11:20:00', engine_no: 'NJSDF23423M' },
                { qrcode: 'qs23357mpm679358', serial_number: '100020503', active_date: '2024-01-21 09:21:00', engine_no: 'N5565JKSDF' },
                { qrcode: 'qs23357mpm679359', serial_number: '100020504', active_date: '2024-02-06 10:49:00', engine_no: 'NJSDF23423M' },
                { qrcode: 'qs23357mpm679310', serial_number: '100020505', active_date: '2024-02-11 16:33:00', engine_no: 'N5565JKSDF' },
            ]
        };
    },
    components: {
        modal,
        modalHistory,
    },
    computed: {
        displayData() {
            if (this.data && this.data.length > 0) {
                return this.data;
            }
            return this.dummyData;
        },
        totalCount() {
            if (this.data && this.data.length > 0) {
                return this.config.total || this.data.length;
            }
            return this.dummyData.length;
        },
        lastPageCount() {
            if (this.data && this.data.length > 0) {
                return this.config.lastPage || 1;
            }
            return Math.ceil(this.dummyData.length / this.config.limit) || 1;
        }
    },
    mounted() {
        this.fetchPaginated();
    },
    watch: {
        'filter': {
            deep: true,
            handler() {
                this.config.page = 1;
                this.fetchPaginated();
            }
        },
        'config.page': {
            handler: 'fetchPaginated'
        },
    },
    methods: {
        showHistory(data) {
            this.modal.dataHistory = data;
            this.modal.modalHistory = true;
        },
        goToPage(page) {
            if (page >= 1 && page <= this.lastPageCount) {
                this.config.page = page;
            }
        },
        fetchPaginated() {
            let filter = JSON.parse(JSON.stringify(this.filter));

            this.$http.get(`/api/qrs/mapping-pkb`, {params: {...filter, page: this.config.page, limit: this.config.limit}})
            .then(async res => {
                let data = res.data.data;
                if (data && data.length > 0) {
                    this.data = data;
                    this.config.lastPage = res.data.meta ? res.data.meta.lastPage : 1;
                    this.config.total = res.data.meta ? res.data.meta.total : data.length;
                } else {
                    this.data = null;
                }
            })
            .catch((err) => {
                console.log(err);
                this.data = null;
            });
        },
        exportToCSV() {
            const list = this.displayData;
            const dataToExport = list.map(item => ({
                'QR Code': item.qrcode,
                'Serial Number': item.serial_number,
                'Tanggal Mapping': item.active_date ? moment(item.active_date).format('DD MMM YYYY | HH:mm') : '-',
                'Nomor Mesin': item.engine_no,
            }));

            const worksheet = XLSX.utils.json_to_sheet(dataToExport);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Detail Mapping QR');

            const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
            XLSX.writeFile(workbook, `detail_mapping_qrcode_${timestamp}.csv`, { bookType: 'csv' });
        }
    }
};
</script>

<style scoped>
.btn-download-csv {
    background-color: white;
    border: 1px solid #E2E8F0;
    padding: 4.5px 16px;
    border-radius: 4px;
    margin: 5px 8px;
    display: flex;
    align-items: center;
    font-size: 13px;
    cursor: pointer;
    font-weight: 500;
    color: #1F2937;
    height: 32px;
}

.btn-download-csv:hover {
    background-color: #F8FAFC;
}

.qtrust-table > thead > tr > th {
    text-align: left;
    border-top: 2px solid #F3F3F3;
    border-bottom: 2px solid #F3F3F3;
    padding: 12px 20px;
    font-size: 13px;
    font-weight: 600;
    color: #2F2F2F;
}

.qtrust-table > tbody > tr > td {
    text-align: left;
    padding: 12px 20px;
    border-bottom: 1px solid #F3F3F3;
    font-size: 13px;
    color: #374151;
}
</style>
